import { ProgressBar, Typography, Stack, tokens } from '@cast/design-system';
import { useClusters } from '@cast/shared-cluster-context-data-access';

import { useTrial } from './TrialProvider';
import { TRIAL_CLUSTER_LIMIT } from './constants';

export const TrialClusterLimitTracker = () => {
  const { isPreTrial: show } = useTrial();

  const { clusters, isLoading, error } = useClusters({ enabled: show });

  if (!show || isLoading || error) {
    return null;
  }

  const connectedClusters = clusters.length;

  return (
    <Stack gap={4} width="390px" data-testid="trial-cluster-limit-tracker">
      <Stack
        direction="row"
        alignItems="baseline"
        justifyContent="space-between"
      >
        <Typography variant="P12R" color="textSecondary">
          5-cluster limit for the limited version
        </Typography>

        <Stack direction="row" alignItems="baseline" gap={4}>
          <Typography
            variant="A1"
            color={
              connectedClusters >= TRIAL_CLUSTER_LIMIT
                ? tokens.theme.fg.status.error
                : tokens.theme.fg.status.neutral
            }
          >
            {Math.min(connectedClusters, TRIAL_CLUSTER_LIMIT)}/
            {TRIAL_CLUSTER_LIMIT}
          </Typography>
          <Typography variant="P12R" color="textSecondary">
            connected
          </Typography>
        </Stack>
      </Stack>

      <ProgressBar
        variant="determinate"
        value={
          (Math.min(connectedClusters, TRIAL_CLUSTER_LIMIT) * 100) /
          TRIAL_CLUSTER_LIMIT
        }
        size="md"
        color="tertiary"
      />
    </Stack>
  );
};
